export default {
  inject: ['orderBindCustomer', 'orderBindCustomerCoupon'],
  data() {
    return {
      // 直接付款存储的优惠券
      coupons: [
        {desc_zh:'',desc_en:'',code:'',status:-1,price:0,dis:false},
      ],

      // 直接付款存储的顾客信息
      customer: {
        customerId: '',
        customerName: '',
        allCoupons: [],
        okCouponCodes: [],
        failedCouponCodes: [],
      },
      couponIndex: '',

      shopowner: {
        customerId: -1,
        // customerName: '',
        allCoupons: [],
        okCouponCodes: [],
        failedCouponCodes: [],
      },
      
      isCouponOk: true, // 优惠券无误

      openFrom: '',
    }
  },
  methods: {
    // 搜索优惠券
    async searchCoupon(index) {
      // @focus="onFocus_forScan" @blur="onBlur_forScan"
      // this.scan_canLeave_x_save(true)
      this.onBlur_forScan()
      if (!this.coupons[index].code) {
        this.coupons[index].desc_zh = ''
        this.coupons[index].desc_en = ''
        this.coupons[index].status = -1
        this.coupons[index].price = 0
      }
      await this.orderCostCalc()
    },
    // 优惠券增减
    addCoupon(index, type) {
      if (type === 1) {
        this.coupons.push({desc_zh:'',desc_en:'',code:'',status:-1,price:0,dis:false})
      } else if (type === -1) {
        const CUSTOMER = this.customer
        const LENG = this.coupons.length
        const CODE = this.coupons[index].code
        // console.log(`%c要删除的优惠码:`, 'color: #f00;', CODE)
        if (CUSTOMER.allCoupons) {
          const ITEM = CUSTOMER.allCoupons.find(x => x.code === CODE)
          if (ITEM) {
            ITEM.checked = false
          }
        }
        if (LENG > 1) {
          this.coupons.splice(index, 1)
          const ticketCodeList = this.coupons.filter(x => x.code).map(x => x.code)
          CUSTOMER.customerId && this.couponsSelectedChange(ticketCodeList)
        } else {
          this.$set(this.coupons, index, {desc_zh:'',desc_en:'',code:'',status:-1,price:0,dis:false})
          CUSTOMER.allCoupons.forEach(x => {
            if (CUSTOMER.okCouponCodes.includes(x.code)) {
              // x1.canUse = true
              this.$set(x, 'canUse', true)
            }
          })
        }
        this.orderCostCalc()
      }
    },
    // 计算订单价格
    orderCostCalc() {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
        // orderItemDetailList: this.orderData.orderItemDetailList,
      }, ticketCodeList = []
      
      rD.orderItemDetailList = this.orderData.orderItemDetailList

      const CUSTOMER = this.customer
      if (CUSTOMER.customerId) {
        rD.customerId = CUSTOMER.customerId
      }

      this.coupons.forEach(x => {
        x.code && ticketCodeList.push(x.code)
      })
      ticketCodeList.length > 0 && (rD.ticketCodeList = ticketCodeList)
      console.log(`%c计算订单价格rD:`, 'color: #f00;', rD)

      return this.$api.order_cost_calc(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%c计算订单价格_R:`, 'color: #00f;', _R)

          this.orderData.serviceFee = _R.serviceFee
          this.orderData.costOrigin = _R.costOrigin
          this.orderData.packageFee = _R.packageFee
          this.orderData.discountFee = _R.discountFee
          this.orderData.unassignCash_ = this.orderData.unassignCash - _R.realDiscountFee
          this.orderData.consumptionTax = _R.consumptionTax
          this.orderData.tip = _R.tip
          this.orderData.userCost = _R.price

          this.couponHandler(_R.resultList)

        } else { this._status(res) }
      })
    },
    couponHandler(resultList) {
      let resultList_ = JSON.parse(JSON.stringify(resultList)).reverse()

      this.isCouponOk = true
      resultList_.forEach(x1 => {
        // 将已勾选的优惠券禁用
        if (this.customer.allCoupons.length) {
          const ITEM = this.customer.allCoupons.find(x2 => x2.code === x1.code)
          if (ITEM) {
            this.$set(ITEM, 'canUse', false)
          }
        }
        
        const ITEM_COUPON = this.coupons.find(x2 => x2.code === x1.code)
        // const ITEM_COUPON_INDEX = this.coupons.findIndex(x2 => x2.code === x1.code)
        // console.log(`%c与返回的优惠券匹配:`, 'color: #f0f;', ITEM_COUPON)
        if (ITEM_COUPON) {
          if (x1.status === 0) {
            ITEM_COUPON.success = true
            const {
              ticketType,
              atLeastCost,
              discountCash,
              discount,
              afterCost,
              afterCash
            } = x1.discountTicket
            let descPrefix_zh = '', descPrefix_en = ''
            if (atLeastCost) {
              descPrefix_zh = '滿$' + atLeastCost
              descPrefix_en = 'Spend $' + atLeastCost
            }
            switch (ticketType) {
              case 1:
                ITEM_COUPON.desc_zh = descPrefix_zh + '立減$' + discountCash
                ITEM_COUPON.desc_en = descPrefix_en + ' Enjoy Discount $' + discountCash
                break
              case 2:
                ITEM_COUPON.desc_zh = descPrefix_zh + '立打' + discount + '折'
                ITEM_COUPON.desc_en = descPrefix_en + ' Enjoy ' + (10 - discount) * 10 + '% Discount Off'
                break
              case 3:
                if (afterCost) {
                  ITEM_COUPON.desc_zh = descPrefix_zh + '立返' + afterCost + '%'
                  ITEM_COUPON.desc_en = descPrefix_en + ' Get $' + afterCost + '%'
                } else {
                  ITEM_COUPON.desc_zh = descPrefix_zh + '立返$' + afterCash
                  ITEM_COUPON.desc_en = descPrefix_en + ' Get $' + afterCash
                }
                break
              case 4:
                ITEM_COUPON.desc_zh = descPrefix_zh + '免单'
                ITEM_COUPON.desc_en = 'Free when spend $' + atLeastCost + ' or more'
                break
            }
            ITEM_COUPON.status = x1.status
          } else {
            ITEM_COUPON.success = false
            ITEM_COUPON.desc_zh = x1.msg
            ITEM_COUPON.desc_en = x1.msg_en
            ITEM_COUPON.status = x1.status
            this.isCouponOk = false
          }
          // resultList_.splice(ITEM_COUPON_INDEX, 1)
        }
      })
    },




    // 清除订单绑定的顾客数据
    clearOrderCustomerAll() {
      const CUSTOMER = this.customer
      const COUPONS = this.coupons

      CUSTOMER.customerId = ''
      CUSTOMER.customerName = ''
      CUSTOMER.allCoupons = []
      CUSTOMER.okCouponCodes = []
      CUSTOMER.failedCouponCodes = []
      COUPONS.splice(0, COUPONS.length)
      COUPONS.push({desc_zh:'',desc_en:'',code:'',status:-1,price:0,dis:false})
      this.isCouponOk = true
      console.log(`%c清空了会员信息`, 'color: #00f;', )
    },
    // 清除订单绑定的顾客数据
    clearOrderCustomer() {
      this.clearOrderCustomerAll()
      this.searchCoupon(0)
    },



    // 给订单绑定顾客数据
    bindOrderCustomer(orderId) {
      this.orderBindCustomer({
        orderId,
        callback: this.orderBindCustomerCallback
      })
    },
    orderBindCustomerCallback(result) {
      console.log(`%c绑定顾客的结果1:`, 'color: #f00;', result)
      const { orderId, customerId, customerName } = result
      const CUSTOMER = this.customer
      
      CUSTOMER.customerId = customerId
      CUSTOMER.customerName = customerName
    },

    // 选择优惠券
    openCouponsSelectDialog(index) {
      this.couponIndex = index
      const CUSTOMER = this.customer
      const COUPONS = this.coupons
      this.openFrom = 'huiyuan'
      
      if (CUSTOMER.customerId && this.orderData.id) {
        const fD = {
          shopId: this.currentShopId,
          customerId: CUSTOMER.customerId,
          id: this.orderData.id
        }

        const ticketCodeList = COUPONS.filter(x => x.code).map(x => x.code)
        ticketCodeList.length > 0 && (fD.ticketCodeList = ticketCodeList)
        
        console.log(`%cfD:`, 'color: #f00;', fD)
        this.$api.order_coupon_get(fD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            console.log(`%c优惠券:`, 'color: #f00;', _R)
            _R.ok.forEach(x1 => { x1.canUse = true })
            _R.failed.forEach(x1 => { x1.canUse = false })
            const RESULT = [ ..._R.ok, ..._R.failed ]
            RESULT.forEach(x => {
              x.startTime_ = x.createTime
              x.endTime_ = x.expiredTime
              this.couponFormat(x)
            })
            // 如果已经查询过，要把之前的勾选结果保留
            if (CUSTOMER.allCoupons.length) {
              CUSTOMER.allCoupons.forEach(x1 => {
                if (x1.checked) {
                  const ITEM = RESULT.find(x2 => x2.code === x1.code)
                  if (ITEM) {
                    ITEM.checked = x1.checked
                    ITEM.canUse = x1.canUse
                  }
                }
              })
            }
            CUSTOMER.okCouponCodes = _R.ok.map(x => x.code)
            CUSTOMER.failedCouponCodes = _R.failed.map(x => x.code)
            CUSTOMER.allCoupons = RESULT

            this.orderBindCustomerCoupon({
              coupons: CUSTOMER.allCoupons,
              callback: this.orderBindCustomerCouponCallback
            })

          } else { this._status(res) }
        })
      // } else {
      //   this.orderBindCustomerCoupon({
      //     coupons: CUSTOMER.allCoupons,
      //     callback: this.orderBindCustomerCouponCallback
      //   })
      }
    },
    // 选择折扣
    openCouponsSelectDialog2() {
      this.couponIndex = this.coupons.length - 1
      const CUSTOMER = this.shopowner
      const COUPONS = this.coupons
      this.openFrom = 'zhekou'
      
      if (CUSTOMER.customerId && this.orderData.id) {
        const fD = {
          shopId: this.currentShopId,
          customerId: CUSTOMER.customerId,
          id: this.orderData.id
        }

        const ticketCodeList = COUPONS.filter(x => x.code).map(x => x.code)
        ticketCodeList.length > 0 && (fD.ticketCodeList = ticketCodeList)
   
        console.log(`%cfD:`, 'color: #f00;', fD)
        this.$api.order_coupon_get(fD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            console.log(`%c优惠券:`, 'color: #f00;', _R)
            _R.ok.forEach(x1 => { x1.canUse = true })
            _R.failed.forEach(x1 => { x1.canUse = false })
            const RESULT = [ ..._R.ok, ..._R.failed ]
            RESULT.forEach(x => {
              x.startTime_ = x.createTime
              x.endTime_ = x.expiredTime
              this.couponFormat(x)
            })
            // 如果已经查询过，要把之前的勾选结果保留
            // if (CUSTOMER.allCoupons.length) {
            //   CUSTOMER.allCoupons.forEach(x1 => {
            //     if (x1.checked) {
            //       const ITEM = RESULT.find(x2 => x2.code === x1.code)
            //       if (ITEM) {
            //         ITEM.checked = x1.checked
            //         ITEM.canUse = x1.canUse
            //       }
            //     }
            //   })
            // }
            CUSTOMER.okCouponCodes = _R.ok.map(x => x.code)
            CUSTOMER.failedCouponCodes = _R.failed.map(x => x.code)
            CUSTOMER.allCoupons = RESULT

            RESULT.length && this.orderBindCustomerCoupon({
              coupons: CUSTOMER.allCoupons,
              callback: this.orderBindCustomerCouponCallback
            })

          } else { this._status(res) }
        })
      // } else {
      //   this.orderBindCustomerCoupon({
      //     coupons: CUSTOMER.allCoupons,
      //     callback: this.orderBindCustomerCouponCallback
      //   })
      }
    },
    orderBindCustomerCouponCallback(result) {
      const COUPONS = this.coupons
      
      console.log(`%c绑定优惠券的结果:`, 'color: #f00;', result)
      const ticketCodeList1 = result.list
      const ticketCodeList2 = COUPONS.filter(x => x.code).map(x => x.code)
      const ticketCodeList = [
        ...ticketCodeList1,
        ...ticketCodeList2
      ]
      if (result.type === 'select') { // 是选择
        this.couponsSelectedChange(ticketCodeList)
      } else if (result.type === 'submit') { // 是提交
        if (ticketCodeList1.length) {
          if (!COUPONS[this.couponIndex].code) {
            COUPONS.splice(this.couponIndex, 1)
          }
          ticketCodeList1.forEach(x => {
            COUPONS.push({desc_zh:'',desc_en:'',code:x,status:-1,price:0,dis:true})
          })
          this.searchCoupon(this.couponIndex)
        }
      }
    },

    async couponsSelectedChange(ticketCodeList = []) {
      this.$store.commit('el_loading_coupon_select_x_save', true)
      const CUSTOMER = {
        huiyuan: this.customer,
        zhekou: this.shopowner,
      }[this.openFrom]
      
      console.log(`%ccoupons:`, 'color: #f00;', ticketCodeList)
      if (ticketCodeList.length) {
        const fD = {
          shopId: this.currentShopId,
          customerId: CUSTOMER.customerId,
          id: this.orderData.id,
          ticketCodeList
        }
        
        await this.$api.order_coupon_change(fD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            console.log(`%c勾选后的新可用优惠券:`, 'color: #f00;', _R.map(x => ({
              [x.code]: x.canUse
            })))
            _R.forEach(x1 => {
              const ITEM = CUSTOMER.allCoupons.find(x2 => x1.code === x2.code)
              if (ITEM) {
                ITEM.canUse = x1.canUse
              }
            })
          } else { this._status(res) }
        })
      } else {
        CUSTOMER.allCoupons.forEach(x1 => {
          if (CUSTOMER.okCouponCodes.includes(x1.code)) {
            x1.canUse = true
          }
        })
      }
      this.$store.commit('el_loading_coupon_select_x_save', false)
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearOrderCustomerAll()
    next()
  },
}